import UserRole from 'app/enums/UserRole'

export default function(input){

    switch(input){

        case UserRole.ADMIN: return 'Admin';
        case UserRole.USER: return 'Veldwerker';
        case UserRole.ADVISOR: return 'Adviseur';
        default: return '';
    }
}